interface Tag {
  name: string;
  tag: string;
}

const tags: Tag[] = [
  { name: 'SOPInstanceUID', tag: '0008|0018' }, // SOP instance UID

  // Patient
  { name: 'PatientName', tag: '0010|0010' },
  { name: 'PatientID', tag: '0010|0020' },
  { name: 'PatientBirthDate', tag: '0010|0030' },
  { name: 'PatientSex', tag: '0010|0040' },
  { name: 'PatientAge', tag: '0010|1010' }, // e.g. 072Y

  // Study / series
  { name: 'StudyInstanceUID', tag: '0020|000d' },
  { name: 'StudyDate', tag: '0008|0020' },
  { name: 'StudyTime', tag: '0008|0030' },
  { name: 'StudyID', tag: '0020|0010' },
  { name: 'AccessionNumber', tag: '0008|0050' },
  { name: 'StudyDescription', tag: '0008|1030' },
  { name: 'Modality', tag: '0008|0060' },
  { name: 'SeriesInstanceUID', tag: '0020|000e' },
  { name: 'SeriesNumber', tag: '0020|0011' },
  { name: 'SeriesDescription', tag: '0008|103e' },
  { name: 'SeriesDate', tag: '0008|0021' },
  { name: 'SeriesTime', tag: '0008|0031' },
  { name: 'InstanceNumber', tag: '0020|0013' },
  { name: 'SliceLocation', tag: '0020|1041' },

  // Window / pixel
  { name: 'WindowLevel', tag: '0028|1050' }, // DICOM Window Center
  { name: 'WindowWidth', tag: '0028|1051' },
  { name: 'Rows', tag: '0028|0010' },
  { name: 'Columns', tag: '0028|0011' },
  { name: 'BitsAllocated', tag: '0028|0100' },
  { name: 'BitsStored', tag: '0028|0101' },
  { name: 'PixelRepresentation', tag: '0028|0103' },
  { name: 'SamplesPerPixel', tag: '0028|0002' },
  { name: 'RescaleIntercept', tag: '0028|1052' },
  { name: 'RescaleSlope', tag: '0028|1053' },
  { name: 'NumberOfFrames', tag: '0028|0008' },

  // Spatial
  { name: 'ImagePositionPatient', tag: '0020|0032' },
  { name: 'ImageOrientationPatient', tag: '0020|0037' },
  { name: 'PixelSpacing', tag: '0028|0030' },
  { name: 'PatientPosition', tag: '0018|5100' },

  // Ultrasound
  { name: 'SequenceOfUltrasoundRegions', tag: '0018|6011' },
  { name: 'PhysicalDeltaX', tag: '0018|602c' },
  { name: 'PhysicalDeltaY', tag: '0018|602e' },
  { name: 'PhysicalUnitsXDirection', tag: '0018|6024' },
  { name: 'PhysicalUnitsYDirection', tag: '0018|6026' },

  // Acquisition parameters
  { name: 'Part', tag: '0032|1060' },
  { name: 'RepetitionTime', tag: '0018|0080' }, // TR
  { name: 'EchoTime', tag: '0018|0081' }, // TE
  { name: 'InversionTime', tag: '0018|0082' }, // TI
  { name: 'FlipAngle', tag: '0018|1314' },
  { name: 'ScanningSequence', tag: '0018|0020' },
  { name: 'SequenceVariant', tag: '0018|0021' },
  { name: 'ScanOptions', tag: '0018|0022' },
  { name: 'MRAcquisitionType', tag: '0018|0023' },
  { name: 'SequenceName', tag: '0018|0024' },
  { name: 'AngioFlag', tag: '0018|0025' },
  { name: 'SliceThickness', tag: '0018|0050' }, // ST
  { name: 'SpacingBetweenSlices', tag: '0018|0088' }, // BS
  { name: 'FieldOfView', tag: '0018|1100' }, // FoV / Reconstruction Diameter
  { name: 'PercentSampling', tag: '0018|0093' },
  { name: 'PercentPhaseFieldOfView', tag: '0018|0094' },
  { name: 'EchoNumbers', tag: '0018|0086' },
  { name: 'NumberOfEchoes', tag: '0018|0086' }, // alias for compatibility
  { name: 'EchoTrainLength', tag: '0018|0091' },

  // Institution / device
  { name: 'InstitutionName', tag: '0008|0080' },
  { name: 'Manufacturer', tag: '0008|0070' },
  { name: 'ManufacturerModelName', tag: '0008|1090' },
  { name: 'DeviceSerialNumber', tag: '0018|1000' },
  { name: 'SoftwareVersions', tag: '0018|1020' },
  { name: 'KVP', tag: '0018|0060' }, // 管电压
  { name: 'ConvolutionKernel', tag: '0018|1210' }, // 重建核
  { name: 'XRayTubeCurrent', tag: '0018|1151' }, //管电流
  { name: 'Exposure', tag: '0018|1150' }, //管电流时间积

  // Timestamps
  { name: 'AcquisitionNumber', tag: '0020|0012' },
  { name: 'AcquisitionDate', tag: '0008|0022' },
  { name: 'AcquisitionTime', tag: '0008|0032' },
  { name: 'AcquisitionDateTime', tag: '0008|002a' },
  { name: 'ContentDate', tag: '0008|0023' },
  { name: 'ContentTime', tag: '0008|0033' },
];

export const TAG_TO_NAME = new Map(tags.map((t) => [t.tag, t.name]));
export const NAME_TO_TAG = new Map(tags.map((t) => [t.name, t.tag]));
export const Tags = Object.fromEntries(tags.map((t) => [t.name, t.tag]));

// Splits an itk-wasm-style "GGGG|EEEE" tag into the numeric [group, element]
// pair emitted by the streaming DICOM parser.
export const tagToGroupElement = (tag: string): [number, number] => {
  const [group, element] = tag.split('|');
  return [parseInt(group, 16), parseInt(element, 16)];
};
